import type { AccountingAccountResource } from "../../accounting-account";

export type AccountingTemplateResource = {
  id: string;
  gid: string;
  category: string;
  title: string;
  description: string;
  accounting_template_positions: AccountingTemplatePositionResource[];
};

export type AccountingTemplatePositionResource = {
  id: string;
  gid: string;
  position_number: string;
  is_credit: boolean;
  accounting_template_id: string;
  accounting_account_id: string;
  accounting_template?: AccountingTemplateResource;
  accounting_account?: AccountingAccountResource;
};

export enum AccountingTemplateCategoryEnum {
  Expenses = "expenses",
  Customer = "customer",
  Supplier = "supplier",
  Other = "other",
}
